"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnnotationCanvasMode = void 0;
var tslib_1 = require("tslib");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../../../utils");
var mode_reducer_1 = require("../../functions/reducer/mode-reducer");
/**
 * @description AnnotationCanvasのモード．
 */
var useAnnotationCanvasMode = function (annotationMode$, moveImageMode$, mouseRightIsDown$, mouseLeftIsDown$, mouseLeaveEnter$, canvasObjectRelativeOnCursorCopy$, rootRectSizeAbsolute$) {
    var mode$ = (0, utils_1.useDataStream)('readonly', annotationMode$.pipe((0, operators_1.switchMap)(function (annotationMode) {
        switch (annotationMode) {
            case 'readonly':
                return (0, rxjs_1.of)('readonly');
            case 'rectbox':
            case 'auto-segmentation':
                return (0, utils_1.mergeTyped)((0, utils_1.mergeTyped)(mouseRightIsDown$, moveImageMode$).pipe((0, operators_1.map)(function (v) { return (v ? 'spaceKey-down' : 'spaceKey-up'); })), mouseLeftIsDown$.pipe((0, operators_1.withLatestFrom)(canvasObjectRelativeOnCursorCopy$), (0, operators_1.map)(function (_a) {
                    var _b = tslib_1.__read(_a, 2), mouseIsDown = _b[0], object = _b[1];
                    if (!mouseIsDown) {
                        return 'mouse-up';
                    }
                    else {
                        if (object === undefined || object === 'background') {
                            return 'background-click';
                        }
                        else {
                            switch (object.type) {
                                case 'face':
                                    return 'bbox-face-click';
                                case 'edge':
                                    return 'bbox-edge-click';
                                case 'point':
                                    return 'bbox-point-click';
                                case 'paint':
                                    return 'paint-object-click';
                                default:
                                    // dummy
                                    return 'background-click';
                            }
                        }
                    }
                })), mouseLeaveEnter$.pipe((0, operators_1.map)(function (e) { return (e === 'enter' ? 'mouse-enter' : 'mouse-leave'); })), rootRectSizeAbsolute$.pipe((0, utils_1.mapToConst)('window-resize'))).pipe((function () {
                    switch (annotationMode) {
                        case 'rectbox':
                            return (0, operators_1.scan)(mode_reducer_1.modeReducerForRectBoxEditor, 'rectbox-editor-standby');
                        case 'auto-segmentation':
                            return (0, operators_1.scan)(mode_reducer_1.modeReducerForAutoSegmentation, 'auto-segmentation-standby');
                    }
                })());
        }
    })));
    return mode$;
};
exports.useAnnotationCanvasMode = useAnnotationCanvasMode;
